import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Box, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { RHFTextField } from "../../components/hook-form";
import FormProvider from "../../components/hook-form/FormProvider";
import RHFJoditEditor from "../../components/hook-form/RHFJoditEditor";
import { Upload } from "../../components/upload";
import { createService, updateService } from "../../redux/slices/serviceSlice";

const ContactForm = ({ handleClose, data, isEdit = false }) => {
  // TODO: hooks

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // TODO: useStates
  const [image, setImage] = useState(null);

  // TODO: get the data from slice

  const createServiceLoading = useSelector((state) => state.page.isLoading);

  const Schema = Yup.object().shape({
    // title: Yup.string().required("Service title is required"),
    // category_id: Yup.string().required("Service category is required"),
    // description: Yup.string().required("Service description is required"),
    // artists: Yup.string().required("Service artists is required"),
    // producer: Yup.string().required("Service producer is required"),
    // duration: Yup.string().required("Service duration is required"),
    // released_date: Yup.string().required("Service released date is required"),
  });
  const defaultValues = useMemo(
    () => ({
      title: data?.title || "",
      description: data?.description || "",
      image: data?.image?.url || "",
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const { handleSubmit } = methods;

  // ======

  // TODO: functions

  // TODO: handle upload image
  const handleDropImage = useCallback((acceptedFiles) => {
    const newFile = acceptedFiles[0];
    if (newFile) {
      setImage(
        Object.assign(newFile, {
          preview: URL.createObjectURL(newFile),
        })
      );
      setImage(acceptedFiles[0]);
    }
  }, []);
  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");
  };
  const onCreateService = (values) => {
    delete values.image;

    // TODO: dispatch the action to create a service
    const formData = new FormData();

    formData.append("name", values.title);
    formData.append("slug", generateSlug(values.title));

    formData.append("description", values.description);

    image && formData.append("image", image);

    dispatch(createService({ data: formData, enqueueSnackbar, handleClose }));
  };

  const onUpdateService = async (values) => {
    const formData = new FormData();

    delete values.image;

    // TODO: dispatch the action to create a service

    formData.append("name", values.title);
    formData.append("slug", generateSlug(values.title));
    formData.append("description", values.description);

    if (image) {
      formData.append("image", image);
    }
    await dispatch(
      updateService({
        data: formData,
        enqueueSnackbar,
        handleClose,
        id: data?.id,
      })
    );
  };

  // TODO: console.logs

  return (
    <Box p={3}>
      <FormProvider
        methods={methods}
        onSubmit={handleSubmit(isEdit ? onUpdateService : onCreateService)}
      >
        <Stack flexDirection={"row"} justifyContent={"center"} mb={2}></Stack>
        <Box
          rowGap={3}
          columnGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: "repeat(1, 1fr)",
            sm: "repeat(1, 1fr)",
          }}
        >
          <RHFTextField name={"title"} label={"Title *"} />
        </Box>

        <Box mt={3}>
          <p className="mb-3">Service's description *</p>
          <RHFJoditEditor name={"description"} />
        </Box>

        <Box mt={3}>
          <Upload
            isAvatar={false}
            text={"Upload image"}
            file={image || defaultValues.image}
            name="image"
            accept="image/*"
            maxSize={1}
            onDrop={handleDropImage}
          />
        </Box>

        <Stack mt={2} alignItems={"end"}>
          <LoadingButton
            loading={createServiceLoading}
            disabled={createServiceLoading}
            type="submit"
            variant="contained"
            className="!bg-primary w-fit"
          >
            {isEdit ? "Update Service" : "Create Service"}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Box>
  );
};

export default ContactForm;
